// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"1831979733d29aae70a1","873":"966d0d75f8f5f5000659"}[chunkId] + ".js";
};